// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__1QB_o","current_route":"styles_current_route__Kznu0"};